import {
  MASTER_HARDWARE_CATALOG_LIST,
  MASTER_HARDWARE_CATALOG_LIST_SUCCESS,
  MASTER_HARDWARE_CATALOG_LIST_FAILURE,
  MASTER_HARDWARE_CATALOG_CREATE,
  MASTER_HARDWARE_CATALOG_CREATE_SUCCESS,
  MASTER_HARDWARE_CATALOG_CREATE_FAILURE,
  MASTER_HARDWARE_CATALOG_UPDATE,
  MASTER_HARDWARE_CATALOG_UPDATE_SUCCESS,
  MASTER_HARDWARE_CATALOG_UPDATE_FAILURE,
  MASTER_HARDWARE_CATALOG_DELETE,
  MASTER_HARDWARE_CATALOG_DELETE_SUCCESS,
  MASTER_HARDWARE_CATALOG_DELETE_FAILURE,
} from "./actionType";

// MASTER_HARDWARE_CATALOG_LIST
export const masterHardwareCatalogList = () => {
  return {
	type: MASTER_HARDWARE_CATALOG_LIST,
  };
};
export const masterHardwareCatalogListSuccess = (data) => {
  return {
	type: MASTER_HARDWARE_CATALOG_LIST_SUCCESS,
	payload: data,
  };
};
export const masterHardwareCatalogListFailure = (error) => {
  return {
	type: MASTER_HARDWARE_CATALOG_LIST_FAILURE,
	payload: error,
  };
};

// MASTER_HARDWARE_CATALOG_CREATE
export const masterHardwareCatalogCreate = (data) => {
  return {
	type: MASTER_HARDWARE_CATALOG_CREATE,
	payload: data,
  };
};
export const masterHardwareCatalogCreateSuccess = (data) => {
  return {
	type: MASTER_HARDWARE_CATALOG_CREATE_SUCCESS,
	payload: data,
  };
};
export const masterHardwareCatalogCreateFailure = (error) => {
  return {
	type: MASTER_HARDWARE_CATALOG_CREATE_FAILURE,
	payload: error,
  };
};

// MASTER_HARDWARE_CATALOG_UPDATE
export const masterHardwareCatalogUpdate = (data) => {
  return {
	type: MASTER_HARDWARE_CATALOG_UPDATE,
	payload: data,
  };
};
export const masterHardwareCatalogUpdateSuccess = (data) => {
  return {
	type: MASTER_HARDWARE_CATALOG_UPDATE_SUCCESS,
	payload: data,
  };
};
export const masterHardwareCatalogUpdateFailure = (error) => {
  return {
	type: MASTER_HARDWARE_CATALOG_UPDATE_FAILURE,
	payload: error,
  };
};

// MASTER_HARDWARE_CATALOG_DELETE
export const masterHardwareCatalogDelete = (data) => {
  return {
	type: MASTER_HARDWARE_CATALOG_DELETE,
	payload: data,
  };
};
export const masterHardwareCatalogDeleteSuccess = (data) => {
  return {
	type: MASTER_HARDWARE_CATALOG_DELETE_SUCCESS,
	payload: data,
  };
};
export const masterHardwareCatalogDeleteFailure = (error) => {
  return {
	type: MASTER_HARDWARE_CATALOG_DELETE_FAILURE,
	payload: error,
  };
};


